import { render, staticRenderFns } from "./AnswerSuggestionExamples.vue?vue&type=template&id=3cf9ab5a&"
import script from "./AnswerSuggestionExamples.vue?vue&type=script&lang=js&"
export * from "./AnswerSuggestionExamples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports